import defaultIcon from '@/assets/image/icons/params/area.png'

const paramsLabelMap = {
    area: 'Площадь дома',
    bedroom: 'Спальни',
    repair: 'Ремонт',
    location: 'Район',
    land: 'Размер участка',
}

export function getParamDescriptionByName(paramName) {
    try {
        return {
            icon: require(`@/assets/image/icons/params/${paramName}.png`),
            label: paramsLabelMap[paramName]
        }
    } catch (e) {
        return {icon: defaultIcon, label: ''};
    }
}